<template>
  <div>
    <loading :active.sync="isLoading" loader="dots"></loading>
    <div class="validate-wrap" v-if="logicTestForm === null">
      <div style="text-align: center;
    background-color: #cbdafc;
    border-radius: 25px;
    padding: 5px;
    width: 125px;
    margin: 0 auto;
    margin-bottom: 30px;">邏輯考試</div>
      <img src="@/assets/img/工作區域 7.png" alt="" />
      <el-select
        v-model="currentPerson.Guid"
        placeholder="請選擇人員"
        style="width: 100%"
      >
        <el-option
          v-for="person in personList"
          :key="person.Value"
          :label="person.Text"
          :value="person.Value"
        >
        </el-option>
      </el-select>

      <el-input
        v-model="currentPerson.IdNo"
        placeholder="請輸入身分證字號"
        style="width: 100%"
      ></el-input>
      <el-button type="primary" @click="validatePerson">確認</el-button>
    </div>

    <el-form
      v-if="logicTestForm !== null && completed === false"
      :model="logicTestForm"
      ref="logicTestForm"
      class="feedback-form"
    >
      <div class="form-title">邏輯考試</div>

      <div class="text-center">
        <el-button
          class="mb-2"
          type="primary"
          :disabled="writing"
          v-if="!writing"
          @click="writing = true"
          >開始填寫</el-button
        >
      </div>
      <table>
        <tr>
          <th scope="row" rowspan="3" class="text-center">基本資料</th>
          <th scope="row">姓名</th>
          <td>
            <el-form-item>
              <el-input v-model="logicTestForm.Arrange.Name" :disabled="true"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <th scope="row">Email</th>
          <td>
            <el-form-item>
              <el-input v-model="logicTestForm.Arrange.Email" :disabled="true"></el-input>
            </el-form-item>
          </td>
        </tr>

        <tr>
          <th scope="row">手機號碼</th>
          <td>
            <el-form-item>
              <el-input v-model="logicTestForm.Arrange.Phone" :disabled="true"></el-input>
            </el-form-item>
          </td>
        </tr>
        <template v-for="(question,index) in logicTestForm.Questions">
          <tr :key="question.Guid">
            <td colspan="2">
              {{ question.Title }}<br />
              <img :src="question.FileDetailBase64" alt="" />
            </td>
            <td>
              <el-form-item
                  :prop="'Questions.' + index + '.Value'"
                  :rules="[
                    {
                      required: true,
                      message: '必填',
                    },
                  ]"
                >
              <el-select v-if="question.InputType === 1" v-model="question.Value" :disabled="!writing">
                <el-option :value="true" label="是"></el-option>
                <el-option :value="false" label="否"></el-option>
              </el-select>

              <el-input
                style="width: 100%"
                type="number" :disabled="!writing"
                v-if="question.InputType === 2"
                v-model="question.Value"
              ></el-input>

              <el-select
                v-if="question.InputType === 3"
                v-model="question.Value"
                style="width: 100%" :disabled="!writing"
              >
                <el-option value="A"></el-option>
                <el-option value="B"></el-option>
                <el-option value="C"></el-option>
              </el-select>
              <el-select
                v-if="question.InputType === 4"
                v-model="question.Value"
                style="width: 100%" :disabled="!writing"
              >
                <el-option value="A"></el-option>
                <el-option value="B"></el-option>
                <el-option value="C"></el-option>
                <el-option value="D"></el-option>
              </el-select>
              <el-select
                v-if="question.InputType === 5"
                v-model="question.Value"
                style="width: 100%" :disabled="!writing"
              >
                <el-option value="A"></el-option>
                <el-option value="B"></el-option>
                <el-option value="C"></el-option>
                <el-option value="D"></el-option>
                <el-option value="E"></el-option>
              </el-select>
              <el-select
                v-if="question.InputType === 6"
                v-model="question.Value"
                style="width: 100%" :disabled="!writing"
              >
                <el-option value="A"></el-option>
                <el-option value="B"></el-option>
                <el-option value="C"></el-option>
                <el-option value="D"></el-option>
                <el-option value="E"></el-option>
                <el-option value="F"></el-option>
              </el-select>
              <el-input
                type="text"
                style="width: 100%"
                v-if="question.InputType === 9"
                v-model="question.Value" :disabled="!writing"
              ></el-input>
              </el-form-item>
            </td>
          </tr>
        </template>
      </table>

      <div class="text-center">
        <el-button
          type="primary"
          round
          style="margin-top: 10px"
          v-if="writing"
          @click="submitForm('logicTestForm')"
          >送出</el-button
        >
      </div>
    </el-form>

    <div class="complete-wrap" v-if="completed">
      <img src="@/assets/img/complete_02.png" alt="" />
      <div class="text">測驗已送出</div>

      <el-button type="primary" @click="goLogin">離 開</el-button>
    </div>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>確實填寫完成?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sendFeedback">確 認</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* global $ */
import { mapGetters } from "vuex";

export default {
  name: "RoomScheduleSetting",

  data() {
    return {
      currentPerson: {
        Guid: null,
        IdNo: null,
      },
      personList: [],
      dialogVisible: false,
      writing: false,
      logicTestForm: null,
      form: {
        radio1: null,
        radio2: null,
        radio3: null,
        radio4: null,
        radio5: null,
      },
      completed: false,
    };
  },

  methods: {
    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },

    getTodayCheckIn() {
      const vm = this;

      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.getTodayLogicTestPerson()
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.personList = response.data.Data;
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    validatePerson() {
      const vm = this;
      
      localStorage.clear();
      localStorage.setItem("i18n-lang", "zh-TW");
      this.$cookies.keys().forEach((cookie) => this.$cookies.remove(cookie));

      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.validateLogicTestPerson(vm.currentPerson)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.logicTestForm = response.data.Data;
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dialogVisible = true;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    sendFeedback() {
      const vm = this;

      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.sendLogicTest(vm.logicTestForm)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.dialogVisible = false;
            vm.completed = true;
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    goLogin() {
      
      
      localStorage.clear();
      localStorage.setItem("i18n-lang", "zh-TW");
      this.$cookies.keys().forEach((cookie) => this.$cookies.remove(cookie));
      this.$router.push({ path: "/login" });
    },
  },

  computed: {
    ...mapGetters(["lang"]),
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  created() {
    this.getTodayCheckIn();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
.validate-wrap {
  max-width: 600px;
  margin: 0 auto;
  padding: 60px;
  text-align: center;
  img {
    width: 300px;
    margin-bottom: 40px;
  }
  .el-select,
  .el-input {
    margin-bottom: 20px;
  }
}
.feedback-form {
  max-width: 960px;
  margin: 20px auto;
  border-radius: 10px;
  background-color: #fff;
  padding: 10px;
  table {
    width: 100%;
    img {
      max-width: 500px;
    }
  }
  .form-title {
    text-align: center;
    font-weight: bold;
    margin: 10px 0;
  }
  th {
    background-color: #f5f5f5;
    font-weight: normal;
    white-space: nowrap;
  }
  td,
  th {
    border: 1px solid #ccc;
    padding: 5px;
    font-size: 0.9em;
  }
  .el-select {
    width: 100%;
  }
  .el-checkbox {
    transform: scale(1.5);
    margin-left: 10px;
    margin-right: 10px;
  }
  /deep/ .el-form-item__error {
    background-color: #f56c6c;
    color: #fff;
    padding: 3px 10px;
    border-radius: 25px;
    float: right;
  }
}

.complete-wrap {
  max-width: 600px;
  margin: 0 auto;
  padding: 60px;
  text-align: center;
  img {
    width: 300px;
    margin-bottom: 40px;
  }
  .text {
    margin-bottom: 40px;
  }
}
</style>
